export const PARTNERS = 'partners';
